
export const assertIdIsNotNullOrUndefined : <T extends { id?: number | null }>(
  object: T
) => asserts object is T & { id: number } = <
  T extends {id?: number | null}
>(object: T): asserts object is T & {id: number} =>{
  if (object.id === null || object.id === undefined) {
    throw new Error("ID must not be null or undefined");
  }
};